import React from "react";
import Panel from "../../../common/components/Panel";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import { PanelModel } from "../../Models/PanelModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";
import PanelAction from "./PanelAction";

const PanelComponent: React.FC<IComponentProps<PanelModel>> = ({ component, context, componentPath = [] }) => {
  const componentLayoutSx = getComponentLayout(component);
  const headerActionSize = component.Compact ? "small" : "medium";

  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: true,
    isEmpty: !component.Children || component.Children.length === 0,
  });

  return (
    <Panel
      headerLabel={component.HeaderLabel}
      headerIconName={component.HeaderIconName}
      headerActions={
        component.HeaderActions ? (
          <PanelAction actions={component.HeaderActions} size={headerActionSize} context={context} ownerComponentId={component.Id} ownerComponentPath={componentPath} />
        ) : undefined
      }
      compact={component.Compact}
      sx={{ m: 1, ...componentLayoutSx }}
      {...selectionProps}
    >
      {component.Children?.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} componentPath={[...componentPath, child.Id]} />
      ))}
    </Panel>
  );
};

export default PanelComponent;
